import { useMutation } from "@apollo/react-hooks";

import { Instructor, Learner, LearnerAllocationStatus } from "@hubcapp/types";
import learners from "@hubcapp/graphql/learners.graphql";
import rejectLearnerMutation from "../graph-ql/rejectLearner.graphql";

const useMutationRejectLearner = (instructorId: string, learnerId: string) =>
  useMutation<{ rejectLearner: Partial<Learner> }>(rejectLearnerMutation, {
    optimisticResponse: () => ({
      rejectLearner: {
        id: learnerId,
        allocations: [
          {
            allocationStatus: LearnerAllocationStatus.Rejected,
          },
        ],
      } as Partial<Learner>,
    }),
    update: (proxy, { data }) => {
      if (data) {
        const learnersQuery = proxy.readQuery<{ instructor: Instructor }>({
          query: learners,
          variables: {
            id: instructorId,
          },
        });

        if (learnersQuery) {
          proxy.writeQuery({
            query: learners,
            variables: { id: instructorId },
            data: {
              instructor: {
                ...learnersQuery.instructor,
                learners: learnersQuery.instructor.learners.filter(
                  learner => learner?.id !== learnerId,
                ),
              },
            },
          });
        }
      }
    },
  });

export default useMutationRejectLearner;
